import { SearchCriteriaNearbyService } from '../../Apartments/Browser/ApartmentSearchCriteria';
import { Language } from '../../Common/interfaces/language';

export class ApplicationAM {
	additionalInformation: string;
	allowOfferingsFromNearbyArea: boolean;
	allowOfferingsFromSameCity: boolean;
	apartmentNeededFrom: Date | undefined;
	applicantType: ApplicantType;
	applicants: ApplicantAM[];
	applicantIsPregnant: boolean;
	numberOfOtherResidents: number;
	otherApplicantsCombinedIncome: number;
	currentResidence: ApplicationCurrentResidenceInfoAM | undefined;
	financialSituation: ApplicationFinancialSituationAM | undefined;
	reasonsForApartmentNeed: ApartmentNeedReason[];
	targets: ApplicationTarget[];
	searchConditions: ApplicationSearchConditions;
	apartmentMinSize: number | undefined;
	apartmentMaxSize: number | undefined;
	language: Language;
	searchAreas: ApplicationSearchArea[];
	estimatedContractLength?: ApplicationEstimatedContractLength;
}

export class ApplicantAM {
	firstName: string;
	lastName: string;
	identificationNumber: string;
	email: string;
	phoneNumber: string;
	profession: string;
	employer: string;
	workSituation?: ApplicationEmploymentStatus;
	businessId?: string;
	companyName?: string;
	monthlyIncome: number;
	streetAddress: string;
	postOffice: string;
	zipCode: string;
	role: ApplicantRole;
}

export class ApplicationTarget {
	preferredTarget: boolean;
	businessEntityId: string | undefined;
	rentalUnitId: string | undefined;
}

export class ApplicationCurrentResidenceInfoAM {
	numberOfResidents: number;
	numberOfRooms: number;
	areaInSqm: number;
	status: CurrentResidenceStatus;
	homelessSince: Date | undefined;
}

export class ApplicationFinancialSituationAM {
	ownedApartment: ApplicationOwnedApartmentDataAM | undefined;
	residentialPropertyCombinedValue: number;
	studentDebt: number;
	otherDebt: number;
	childSupportDebt: number;
	investmentFundsValue: number;
	stockPortfolioValue: number;
	vacationHome: boolean;
	otherRealEstate: boolean;
}

export class ApplicationOwnedApartmentDataAM {
	location: string;
}

export class ApplicationSearchConditions {
	maxRent: number;
	features: ApplicationApartmentFeature[];
	apartmentTypes: ApplicationApartmentType[];
	buildingTypes: ApplicationBuildingType[];
	nearbyServices?: SearchCriteriaNearbyService[];
}

export class ApplicationSearchArea {
	city?: string;
	district?: string;
	marketingZone?: string;
	street?: string;
	zipCode?: string;
}

export const enum ApplicationEstimatedContractLength {
	NotSet = 'NotSet',
	UnderOneYear = 'UnderOneYear',
	OneToThreeYears = 'OneToThreeYears',
	ThreeToFiveYears = 'ThreeToFiveYears',
	OverFiveYears = 'OverFiveYears',
}

export const enum ApplicationEmploymentStatus {
	NotSet = 'NotSet',
	Employed = 'Employed',
	Unemployed = 'Unemployed',
	Student = 'Student',
	Retired = 'Retired',
}

export enum ApplicantType {
	Person,
	Company,
	ServiceRequest,
}

export enum CurrentResidenceStatus {
	CurrentCustomer,
	RentalApartment,
	OwnApartment,
	PartiallyOwnedApartment,
	EmployerApartment,
	StudentApartment,
	Subtenant,
	ParentsApartment,
	RelativesApartment,
	DormOrFacility,
	Homeless,
}

export enum ApplicationApartmentFeature {
	Balcony,
	Sauna,
	Elevator,
	ParkingSpace,
	Laundry,
}

export enum ApartmentNeedReason {
	FamilySizeDecrease,
	FamilySizeIncrease,
	DomesticPartnershipEnding,
	Divorce,
	BeginningOfRelationship,
	BecomingIndependent,
	ChangingLocality,
	ProximityToWork,
	CurrentApartmentTooSmall,
	CurrentApartmentTooBig,
	CurrentApartmentTooExpensive,
	CurrentApartmentQuality,
	NeedForAccessibility,
	NeedForSeniorHousing,
	CurrentContractTerminated,
	Evicted,
	CurrentApartmentSold,
}

export enum ApplicantRole {
	PrincipalTenant,
	CoTenant,
	CompanyContactPerson,
}

export enum ApplicationApartmentType {
	OneRoom,
	TwoRoom,
	ThreeRoom,
	FourRoom,
	FiveOrMore,
}

export enum ApplicationBuildingType {
	Block,
	RowHouse,
}
